import { render, staticRenderFns } from "./UsedTicketCard.vue?vue&type=template&id=ff34b8b6"
import script from "./UsedTicketCard.vue?vue&type=script&lang=js"
export * from "./UsedTicketCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports